import {
  SET_SHOW_ALL_NUM,
  GET_PRODUCTS,
  UPDATE_CART_DATA,
  EMPTY_CART,
  ADD_TO_CART,
  REMOVE_FROM_CART,
  DECREASE_COUNT_FROM_CART,
  GET_USER,
  SET_USER,
  REMOVE_USER,
  GET_BLOGS,
  SET_USER_ADDRESS,
} from "../Types";

export const getAllProducts = (products) => {
  return { type: GET_PRODUCTS, payload: products };
};

export const updateCartData = (cart) => {
  return { type: UPDATE_CART_DATA, payload: cart };
};

export const emptyCart = (cart) => {
  return { type: EMPTY_CART, payload: cart };
};

export const addToCart = (product) => {
  return { type: ADD_TO_CART, payload: product };
};

export const removeFromCart = (product) => {
  return { type: REMOVE_FROM_CART, payload: product };
};

export const decreaseCountFromCart = (product) => {
  return { type: DECREASE_COUNT_FROM_CART, payload: product };
};

export const getBlogs = (blogs) => {
  return { type: GET_BLOGS, payload: blogs };
};

export const getUser = (user) => {
  return { type: GET_USER, payload: user };
};

export const setUser = (user) => {
  return { type: SET_USER, payload: user };
};

export const setUserAddress = (user) => {
  return { type: SET_USER_ADDRESS, payload: user };
};

export const removeUser = (user) => {
  return { type: REMOVE_USER, payload: user };
};

export const setShowAllNum = (num) => {
  return { type: SET_SHOW_ALL_NUM, payload: num };
};
